$(document).ready(function () {
    $('.pss-owl-slider').owlCarousel({
        items: 4.5,
        margin: 24,
        loop: 0,
        autoplay: 0,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        animateOut: false,
        smartSpeed: 1000,
        nav: true,
        navText: ['<span></span>', '<span></span>'],
        dots: 0,
        mouseDrag: true,
        touchDrag: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            480: {
                items: 1.5,
                nav: true
            },
            768: {
                items: 2.5,
                nav: true
            },
            1024: {
                items: 3.5,
                nav: true
            },
            1280: {
                items: 4.5,
                nav: true
            }
        }
    });



// ── Linear Announcement Bar ──────────────────────────────────
  var $linearSlider = $('.announcement-linear-slider');
  if ($linearSlider.length) {
    $linearSlider.owlCarousel({
      items: 9,
      loop: true,
      margin: 50,
      autoplay: true,
      nav: false,
      dots: false,
      slideTransition: 'linear',
      autoplayTimeout: 3000,
      autoplaySpeed: 5000,
      smartSpeed: 3000,
      autoplayHoverPause: true,
      autoWidth: true,
      responsive: {
        0:    { items: 3, margin: 10, autoWidth: true },
        428:  { items: 3, margin: 30, autoWidth: true },
        540:  { items: 4, margin: 50 },
        768:  { items: 6, margin: 50 },
        1024: { items: 8, margin: 50 },
        1440: { items: 9, margin: 70 },
        1920: { items: 9, margin: 70 }
      }
    });
  }


  // footer shop all link hide on desktop 
  $('.footer-block .footer-block-heading').each(function () {
    if ($(this).text().trim() === 'Shop All') {
      $(this).closest('.block-item').addClass('hide-block');
    }
  });

  // media grid layout sldier on mobile
  if ($(window).width() <= 767 && $('.media-grid-design2').length) {
    $('.media-grid-design2 .slider').removeClass('slider');
    $('.media-grid-design2 .slider-wrapper').removeClass('slider-wrapper');
    $('.media-grid-design2 .slider-slide').removeClass('slider-slide');
    $('.media-grid-design2 .slider-seek-bar').hide();
  }

});

//////////// below code is remove element in dropdown js //////////////

document.addEventListener('DOMContentLoaded', function () {
    const sortSelect = document.getElementById('Sort-By');

    if (sortSelect) {
        ['created-ascending', 'created-descending'].forEach(function(value) {
            const option = sortSelect.querySelector(`option[value="${value}"]`);
            if (option) {
                option.remove();
            }
        });
    }
});

document.addEventListener("DOMContentLoaded", () => {
  if (!window.matchMedia("(max-width: 767px)").matches) return;

  document
    .querySelectorAll(".main-collection-text-image__wrapper expandable-container")
    .forEach((container) => {
      const content = container.querySelector(".content-main");
      const button = container.querySelector(".expand-button");

      if (!content || !button) return;

      if (content.scrollHeight > content.clientHeight + 1) {
        container.classList.add("has-overflow");
      }

      button.addEventListener("click", () => {
        const expanded = container.classList.toggle("is-expanded");

        button.setAttribute("aria-expanded", expanded);

        button.querySelector(".read-more-text").classList.toggle("hidden", expanded);
        button.querySelector(".read-less-text").classList.toggle("hidden", !expanded);
      });
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const policyTitle = document.querySelector(".shopify-policy__title h1");

  if (policyTitle && policyTitle.textContent.trim() === "Shipping policy") {
    policyTitle.closest(".shopify-policy__title").style.display = "none";
  }
});